import { IconChevronDown } from '@hulu-react-style-components/icons';

import { IconWrapper } from './styled';

type Props = {
  active?: boolean;
  dataTestId?: string;
};

const DropdownIndicator = ({ active = false, dataTestId = '' }: Props): JSX.Element => (
  <IconWrapper $active={active} className="dropdownIndicator">
    <IconChevronDown data-testid={`${dataTestId}${active ? 'Opened' : 'Closed'}Icon`} />
  </IconWrapper>
);

export default DropdownIndicator;
